import gql from "graphql-tag";

export const MY_HR_ORG_UNITS_SUBSCRIPTION = gql`
  subscription orgUnits(
    $searchField: String
    $searchText: String
    $sort: String
    $page: Int
    $pageSize: Int
  ) {
    orgUnits(
      searchField: $searchField
      searchText: $searchText
      sort: $sort
      page: $page
      pageSize: $pageSize
    ) {
      availableList {
        _id
        code
        name
      }
      availableList {
        _id
        code
        name
      }
      total
      page
      pageSize
      totalPages
    }
  }
`;
